module.exports = "<div data-component=\"last-transaction\" *ngIf=\"transactionCount\">\n\t<div class=\"box\" routerLink=\"/transacoes\">\n\t\t<h3>Transações pendentes ({{ transactionCount }})</h3>\n\t\t<h5>Operações que requerem ação do titular</h5>\n\t\t<button class=\"btn-arrow\" ><i class=\"material-icons\">&#xE315;</i></button>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/last-transactions/last-transactions.component.html
// module id = ../../../../../src/app/master/dashboard/last-transactions/last-transactions.component.html
// module chunks = main